import { api } from "./api";

let _cache = null;
let _pending = null;

// Cached fetch of admin-controlled comparison/snippet field visibility.
export async function getDisplayConfig() {
  if (_cache) return _cache;
  if (!_pending) {
    _pending = api
      .get("/display-config")
      .then((r) => { _cache = r.data; return _cache; })
      .catch(() => ({}));
  }
  return _pending;
}

export function enabledFields(config, section) {
  const list = (config && config[section]) || [];
  return list.filter((f) => f.enabled && f.key);
}
